import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminDelivery() {
  const [d, setD] = useState({ free_threshold: 40, options: [] });
  useEffect(() => { api.get("/content/delivery_settings").then((r) => setD(r.data?.data || { free_threshold: 40, options: [] })); }, []);
  const updOpt = (i, k, v) => setD({ ...d, options: d.options.map((o, x) => x === i ? { ...o, [k]: k === "price" ? v : v } : o) });
  const save = async () => {
    const payload = { free_threshold: Number(d.free_threshold), options: d.options.map((o) => ({ ...o, price: Number(o.price) })) };
    await api.put("/content/delivery_settings", payload); toast.success("Delivery settings saved");
  };
  return (
    <div>
      <h1 className="font-serif-display text-4xl mb-8">Delivery settings</h1>
      <div className="bg-white border border-brand-border rounded-sm p-6 max-w-2xl space-y-5">
        <div><label className="text-xs uppercase tracking-luxe block mb-1">Free delivery threshold (£)</label>
          <input type="number" value={d.free_threshold} onChange={(e) => setD({ ...d, free_threshold: e.target.value })} className="border border-brand-border rounded-sm px-3 py-2 text-sm w-40" data-testid="free-threshold" /></div>
        <div>
          <label className="text-xs uppercase tracking-luxe block mb-2">Delivery options</label>
          <div className="space-y-3">
            {d.options.map((o, i) => (
              <div key={i} className="flex gap-2 items-center" data-testid={`delivery-option-${i}`}>
                <input value={o.id} onChange={(e) => updOpt(i, "id", e.target.value)} placeholder="id" className="w-28 border border-brand-border rounded-sm px-2 py-1.5 text-sm" />
                <input value={o.name} onChange={(e) => updOpt(i, "name", e.target.value)} placeholder="Name" className="flex-1 border border-brand-border rounded-sm px-2 py-1.5 text-sm" />
                <input value={o.estimate} onChange={(e) => updOpt(i, "estimate", e.target.value)} placeholder="Estimate" className="flex-1 border border-brand-border rounded-sm px-2 py-1.5 text-sm" />
                <input type="number" value={o.price} onChange={(e) => updOpt(i, "price", e.target.value)} placeholder="£" className="w-20 border border-brand-border rounded-sm px-2 py-1.5 text-sm" />
                <button onClick={() => setD({ ...d, options: d.options.filter((_, x) => x !== i) })} className="text-destructive"><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
          <button onClick={() => setD({ ...d, options: [...d.options, { id: "new", name: "", estimate: "", price: 0 }] })} className="text-sm underline flex items-center gap-1 mt-3"><Plus className="w-4 h-4" /> Add option</button>
        </div>
        <button onClick={save} className="bg-brand-ink text-white px-8 py-3 rounded-sm text-sm uppercase tracking-luxe hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid="save-delivery">Save settings</button>
      </div>
    </div>
  );
}
